import { ContractResponse } from '../contract-response.model';
import {
  DeliveryRequest,
  DematDeliveryContractData,
  DematDeliveryData
} from './demat-delivery/demat-delivery.component.model';
import { VehicleCategory, VehicleData } from '../../../../core/services/application.model';
import { TranslateService } from '@ngx-translate/core';

export const contractResponseToDematDeliveryContractData = (
  contract: ContractResponse,
  translateService: TranslateService
): DematDeliveryContractData => {
  const translatedCivility =
    contract.holder.type === 'PHYSICAL'
      ? translateService.instant(
          `application.demat-delivery.civility.${contract.holder.physicalPerson?.civility.toLowerCase()}`
        )
      : translateService.instant(
          `application.demat-delivery.civility.${contract.holder.legalEntity?.legalRepresentative.civility.toLowerCase()}`
        );
  return {
    emailAddress: contract.holder.physicalPerson?.mail ?? contract.holder.legalEntity?.legalRepresentative?.mail ?? '',
    mobilePhoneNumber:
      contract.holder.physicalPerson?.mobilePhone ?? contract.holder.legalEntity?.legalRepresentative?.cellPhone ?? '',
    vehicleCategory: (contract.vehicle.category as VehicleCategory) ?? null,
    registrationNumber: contract.vehicle.registrationNumber,
    serialNumber: contract.vehicle.vin,
    usedVehicle: contract.vehicle.used,
    holderName:
      contract.holder.type === 'PHYSICAL'
        ? `${translatedCivility} ${contract.holder.physicalPerson?.firstName} ${contract.holder.physicalPerson?.lastName}`
        : `${translatedCivility} ${contract.holder.legalEntity?.legalRepresentative.firstName} ${contract.holder.legalEntity?.legalRepresentative.lastName}`,
    import: contract.vehicle.imported
  };
};

export const contractResponseToVehicleData = (contract: ContractResponse): VehicleData => {
  return {
    category: (contract.vehicle.category as VehicleCategory) || null,
    registrationNumber: contract.vehicle.registrationNumber,
    vinNumber: contract.vehicle.vin,
    used: contract.vehicle.used,
    import: contract.vehicle.imported
  };
};

export const dematDeliveryDataToDeliveryRequest = (dematDelivery: DematDeliveryData): DeliveryRequest => {
  return {
    distanceSignature: dematDelivery.distanceSignature,
    holder: {
      contactData: {
        emailAddress: dematDelivery.emailAddress,
        mobilePhoneNumber: `+33${dematDelivery.mobilePhoneNumber.slice(1)}`
      }
    },
    project: {
      vehicle: {
        registrationNumber: dematDelivery.registrationNumber,
        serialNumber: dematDelivery.serialNumber
      }
    }
  };
};
